import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-paremployee-document-delete-dialog',
  templateUrl: './paremployee-document-delete-dialog.component.html',
  styleUrls: ['./paremployee-document-delete-dialog.component.css']
})
export class ParemployeeDocumentDeleteDialogComponent implements OnInit {
  errFlag: boolean = false;
  errMsg: any;
  DocTypeErrMsg: any;
  DocTypeErr:boolean = false;
  logFormData: any;
  loginId: any;
  docId: any;
  firstName;
  lastName;
  constructor(private googleAnalyticsService:GoogleAnalyticsService,
    private changelogservice: ChangeLogService, private parEmployeeService: ParEmployeeService, public dialog: MatDialog, public dialogRef: MatDialogRef<ParemployeeDocumentDeleteDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public DocumentData: any) {
     }

  ngOnInit() {
   this.loginId = localStorage.getItem('loginID');
   this.firstName =  localStorage.getItem("username");
   this.lastName = localStorage.getItem('Lastname');
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDocument() {
    this.logFormData = {
      "document_type": this.DocumentData.DocumentData.DocumentTypeName,
      "document_category": this.DocumentData.DocumentData.DocumentCategory,
      "transaction_type": "Delete",
      "employee_name": localStorage.getItem('EmployeeName')
    }
    this.docId = this.DocumentData.DocumentData._id;
    this.parEmployeeService.deleteParEmployeeDocument(this.docId).subscribe(res => {
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.DocumentData.DocumentData.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
      this.parEmployeeService.load.next('success');
      this.onNoClick();
      this.logFormData.modified_by = this.loginId;
      this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
        this.errMsg = 'PAR Change Logs' + ' ' + err;
        this.errFlag = true;
      });
    }, error => {
      this.DocTypeErrMsg = "Delete PAREmployee Documents" + error;
      this.DocTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-document-delete-dialog/paremployee-document-delete-dialog.component.ts